// Untyped client for tables/columns added by migrations that the generated
// `types.ts` doesn't know yet (payments, quote_requests.deposit_amount_ghs).
// After applying the migrations, regenerate types and switch callers back to
// the typed `supabase` client, then delete this file.
import type { SupabaseClient } from "@supabase/supabase-js";
import { supabase } from "./client";

export const db = supabase as unknown as SupabaseClient;
